// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v7.34.1
// source: translations.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "translations";

export interface LocalizedText {
  languageCode: string;
  text: string;
  isAutoTranslated: boolean;
}

export interface TranslationReferences {
  topics: { [key: string]: boolean };
  sms: { [key: string]: boolean };
  greetings: { [key: string]: boolean };
  disclaimerMessages: { [key: string]: boolean };
  behaviour: { [key: string]: boolean };
}

export interface TranslationReferences_TopicsEntry {
  key: string;
  value: boolean;
}

export interface TranslationReferences_SmsEntry {
  key: string;
  value: boolean;
}

export interface TranslationReferences_GreetingsEntry {
  key: string;
  value: boolean;
}

export interface TranslationReferences_DisclaimerMessagesEntry {
  key: string;
  value: boolean;
}

export interface TranslationReferences_BehaviourEntry {
  key: string;
  value: boolean;
}

export interface TranslationEntry {
  id: string;
  translationKey: string;
  translations: LocalizedText[];
  createdAt: Date | undefined;
  updatedAt?: Date | undefined;
  createdBy: string;
  updatedBy?: string | undefined;
  references?: TranslationReferences | undefined;
}

export interface Translations {
  translations: TranslationEntry[];
}

export interface UpdateEntry {
  languageCode: string;
  text?: string | undefined;
  isAutoTranslated?: boolean | undefined;
}

export interface LanguageHubTranslationsCreate {
  id: string;
  translationKey: string;
  translations: LocalizedText[];
}

export interface LanguageHubTranslationsUpdate {
  id: string;
  translationKey?: string | undefined;
  translations: UpdateEntry[];
}

export interface LanguageHubTranslationsDelete {
  id: string;
}

function createBaseLocalizedText(): LocalizedText {
  return { languageCode: "", text: "", isAutoTranslated: false };
}

export const LocalizedText: MessageFns<LocalizedText> = {
  encode(message: LocalizedText, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.languageCode !== "") {
      writer.uint32(10).string(message.languageCode);
    }
    if (message.text !== "") {
      writer.uint32(18).string(message.text);
    }
    if (message.isAutoTranslated !== false) {
      writer.uint32(24).bool(message.isAutoTranslated);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LocalizedText {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocalizedText();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isAutoTranslated = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LocalizedText {
    return {
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : "",
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      isAutoTranslated: isSet(object.isAutoTranslated)
        ? globalThis.Boolean(object.isAutoTranslated)
        : isSet(object.is_auto_translated)
        ? globalThis.Boolean(object.is_auto_translated)
        : false,
    };
  },

  toJSON(message: LocalizedText): unknown {
    const obj: any = {};
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.isAutoTranslated !== false) {
      obj.isAutoTranslated = message.isAutoTranslated;
    }
    return obj;
  },

  create(base?: DeepPartial<LocalizedText>): LocalizedText {
    return LocalizedText.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LocalizedText>): LocalizedText {
    const message = createBaseLocalizedText();
    message.languageCode = object.languageCode ?? "";
    message.text = object.text ?? "";
    message.isAutoTranslated = object.isAutoTranslated ?? false;
    return message;
  },
};

function createBaseTranslationReferences(): TranslationReferences {
  return { topics: {}, sms: {}, greetings: {}, disclaimerMessages: {}, behaviour: {} };
}

export const TranslationReferences: MessageFns<TranslationReferences> = {
  encode(message: TranslationReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.topics).forEach(([key, value]: [string, boolean]) => {
      TranslationReferences_TopicsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    globalThis.Object.entries(message.sms).forEach(([key, value]: [string, boolean]) => {
      TranslationReferences_SmsEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    globalThis.Object.entries(message.greetings).forEach(([key, value]: [string, boolean]) => {
      TranslationReferences_GreetingsEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    globalThis.Object.entries(message.disclaimerMessages).forEach(([key, value]: [string, boolean]) => {
      TranslationReferences_DisclaimerMessagesEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    globalThis.Object.entries(message.behaviour).forEach(([key, value]: [string, boolean]) => {
      TranslationReferences_BehaviourEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TranslationReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTranslationReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = TranslationReferences_TopicsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.topics[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = TranslationReferences_SmsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.sms[entry2.key] = entry2.value;
          }
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = TranslationReferences_GreetingsEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.greetings[entry3.key] = entry3.value;
          }
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = TranslationReferences_DisclaimerMessagesEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.disclaimerMessages[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = TranslationReferences_BehaviourEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.behaviour[entry5.key] = entry5.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TranslationReferences {
    return {
      topics: isObject(object.topics)
        ? (globalThis.Object.entries(object.topics) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      sms: isObject(object.sms)
        ? (globalThis.Object.entries(object.sms) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      greetings: isObject(object.greetings)
        ? (globalThis.Object.entries(object.greetings) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      disclaimerMessages: isObject(object.disclaimerMessages)
        ? (globalThis.Object.entries(object.disclaimerMessages) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.disclaimer_messages)
        ? (globalThis.Object.entries(object.disclaimer_messages) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      behaviour: isObject(object.behaviour)
        ? (globalThis.Object.entries(object.behaviour) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: TranslationReferences): unknown {
    const obj: any = {};
    if (message.topics) {
      const entries = globalThis.Object.entries(message.topics) as [string, boolean][];
      if (entries.length > 0) {
        obj.topics = {};
        entries.forEach(([k, v]) => {
          obj.topics[k] = v;
        });
      }
    }
    if (message.sms) {
      const entries = globalThis.Object.entries(message.sms) as [string, boolean][];
      if (entries.length > 0) {
        obj.sms = {};
        entries.forEach(([k, v]) => {
          obj.sms[k] = v;
        });
      }
    }
    if (message.greetings) {
      const entries = globalThis.Object.entries(message.greetings) as [string, boolean][];
      if (entries.length > 0) {
        obj.greetings = {};
        entries.forEach(([k, v]) => {
          obj.greetings[k] = v;
        });
      }
    }
    if (message.disclaimerMessages) {
      const entries = globalThis.Object.entries(message.disclaimerMessages) as [string, boolean][];
      if (entries.length > 0) {
        obj.disclaimerMessages = {};
        entries.forEach(([k, v]) => {
          obj.disclaimerMessages[k] = v;
        });
      }
    }
    if (message.behaviour) {
      const entries = globalThis.Object.entries(message.behaviour) as [string, boolean][];
      if (entries.length > 0) {
        obj.behaviour = {};
        entries.forEach(([k, v]) => {
          obj.behaviour[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<TranslationReferences>): TranslationReferences {
    return TranslationReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TranslationReferences>): TranslationReferences {
    const message = createBaseTranslationReferences();
    message.topics = (globalThis.Object.entries(object.topics ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.sms = (globalThis.Object.entries(object.sms ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.greetings = (globalThis.Object.entries(object.greetings ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.disclaimerMessages = (globalThis.Object.entries(object.disclaimerMessages ?? {}) as [string, boolean][])
      .reduce((acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      }, {});
    message.behaviour = (globalThis.Object.entries(object.behaviour ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseTranslationReferences_TopicsEntry(): TranslationReferences_TopicsEntry {
  return { key: "", value: false };
}

export const TranslationReferences_TopicsEntry: MessageFns<TranslationReferences_TopicsEntry> = {
  encode(message: TranslationReferences_TopicsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TranslationReferences_TopicsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTranslationReferences_TopicsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TranslationReferences_TopicsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: TranslationReferences_TopicsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<TranslationReferences_TopicsEntry>): TranslationReferences_TopicsEntry {
    return TranslationReferences_TopicsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TranslationReferences_TopicsEntry>): TranslationReferences_TopicsEntry {
    const message = createBaseTranslationReferences_TopicsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseTranslationReferences_SmsEntry(): TranslationReferences_SmsEntry {
  return { key: "", value: false };
}

export const TranslationReferences_SmsEntry: MessageFns<TranslationReferences_SmsEntry> = {
  encode(message: TranslationReferences_SmsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TranslationReferences_SmsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTranslationReferences_SmsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TranslationReferences_SmsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: TranslationReferences_SmsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<TranslationReferences_SmsEntry>): TranslationReferences_SmsEntry {
    return TranslationReferences_SmsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TranslationReferences_SmsEntry>): TranslationReferences_SmsEntry {
    const message = createBaseTranslationReferences_SmsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseTranslationReferences_GreetingsEntry(): TranslationReferences_GreetingsEntry {
  return { key: "", value: false };
}

export const TranslationReferences_GreetingsEntry: MessageFns<TranslationReferences_GreetingsEntry> = {
  encode(message: TranslationReferences_GreetingsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TranslationReferences_GreetingsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTranslationReferences_GreetingsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TranslationReferences_GreetingsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: TranslationReferences_GreetingsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<TranslationReferences_GreetingsEntry>): TranslationReferences_GreetingsEntry {
    return TranslationReferences_GreetingsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TranslationReferences_GreetingsEntry>): TranslationReferences_GreetingsEntry {
    const message = createBaseTranslationReferences_GreetingsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseTranslationReferences_DisclaimerMessagesEntry(): TranslationReferences_DisclaimerMessagesEntry {
  return { key: "", value: false };
}

export const TranslationReferences_DisclaimerMessagesEntry: MessageFns<TranslationReferences_DisclaimerMessagesEntry> =
  {
    encode(
      message: TranslationReferences_DisclaimerMessagesEntry,
      writer: BinaryWriter = new BinaryWriter(),
    ): BinaryWriter {
      if (message.key !== "") {
        writer.uint32(10).string(message.key);
      }
      if (message.value !== false) {
        writer.uint32(16).bool(message.value);
      }
      return writer;
    },

    decode(input: BinaryReader | Uint8Array, length?: number): TranslationReferences_DisclaimerMessagesEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseTranslationReferences_DisclaimerMessagesEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.key = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.value = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    },

    fromJSON(object: any): TranslationReferences_DisclaimerMessagesEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : "",
        value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
      };
    },

    toJSON(message: TranslationReferences_DisclaimerMessagesEntry): unknown {
      const obj: any = {};
      if (message.key !== "") {
        obj.key = message.key;
      }
      if (message.value !== false) {
        obj.value = message.value;
      }
      return obj;
    },

    create(
      base?: DeepPartial<TranslationReferences_DisclaimerMessagesEntry>,
    ): TranslationReferences_DisclaimerMessagesEntry {
      return TranslationReferences_DisclaimerMessagesEntry.fromPartial(base ?? {});
    },
    fromPartial(
      object: DeepPartial<TranslationReferences_DisclaimerMessagesEntry>,
    ): TranslationReferences_DisclaimerMessagesEntry {
      const message = createBaseTranslationReferences_DisclaimerMessagesEntry();
      message.key = object.key ?? "";
      message.value = object.value ?? false;
      return message;
    },
  };

function createBaseTranslationReferences_BehaviourEntry(): TranslationReferences_BehaviourEntry {
  return { key: "", value: false };
}

export const TranslationReferences_BehaviourEntry: MessageFns<TranslationReferences_BehaviourEntry> = {
  encode(message: TranslationReferences_BehaviourEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TranslationReferences_BehaviourEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTranslationReferences_BehaviourEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TranslationReferences_BehaviourEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: TranslationReferences_BehaviourEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<TranslationReferences_BehaviourEntry>): TranslationReferences_BehaviourEntry {
    return TranslationReferences_BehaviourEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TranslationReferences_BehaviourEntry>): TranslationReferences_BehaviourEntry {
    const message = createBaseTranslationReferences_BehaviourEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseTranslationEntry(): TranslationEntry {
  return {
    id: "",
    translationKey: "",
    translations: [],
    createdAt: undefined,
    updatedAt: undefined,
    createdBy: "",
    updatedBy: undefined,
    references: undefined,
  };
}

export const TranslationEntry: MessageFns<TranslationEntry> = {
  encode(message: TranslationEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.translationKey !== "") {
      writer.uint32(18).string(message.translationKey);
    }
    for (const v of message.translations) {
      LocalizedText.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(42).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(50).string(message.createdBy);
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(58).string(message.updatedBy);
    }
    if (message.references !== undefined) {
      TranslationReferences.encode(message.references, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TranslationEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTranslationEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.translationKey = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.translations.push(LocalizedText.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.references = TranslationReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TranslationEntry {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      translationKey: isSet(object.translationKey)
        ? globalThis.String(object.translationKey)
        : isSet(object.translation_key)
        ? globalThis.String(object.translation_key)
        : "",
      translations: globalThis.Array.isArray(object?.translations)
        ? object.translations.map((e: any) => LocalizedText.fromJSON(e))
        : [],
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
      references: isSet(object.references) ? TranslationReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: TranslationEntry): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.translationKey !== "") {
      obj.translationKey = message.translationKey;
    }
    if (message.translations?.length) {
      obj.translations = message.translations.map((e) => LocalizedText.toJSON(e));
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    if (message.references !== undefined) {
      obj.references = TranslationReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<TranslationEntry>): TranslationEntry {
    return TranslationEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TranslationEntry>): TranslationEntry {
    const message = createBaseTranslationEntry();
    message.id = object.id ?? "";
    message.translationKey = object.translationKey ?? "";
    message.translations = object.translations?.map((e) => LocalizedText.fromPartial(e)) || [];
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedBy = object.updatedBy ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? TranslationReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseTranslations(): Translations {
  return { translations: [] };
}

export const Translations: MessageFns<Translations> = {
  encode(message: Translations, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.translations) {
      TranslationEntry.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Translations {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTranslations();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.translations.push(TranslationEntry.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Translations {
    return {
      translations: globalThis.Array.isArray(object?.translations)
        ? object.translations.map((e: any) => TranslationEntry.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Translations): unknown {
    const obj: any = {};
    if (message.translations?.length) {
      obj.translations = message.translations.map((e) => TranslationEntry.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<Translations>): Translations {
    return Translations.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Translations>): Translations {
    const message = createBaseTranslations();
    message.translations = object.translations?.map((e) => TranslationEntry.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateEntry(): UpdateEntry {
  return { languageCode: "", text: undefined, isAutoTranslated: undefined };
}

export const UpdateEntry: MessageFns<UpdateEntry> = {
  encode(message: UpdateEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.languageCode !== "") {
      writer.uint32(10).string(message.languageCode);
    }
    if (message.text !== undefined) {
      writer.uint32(18).string(message.text);
    }
    if (message.isAutoTranslated !== undefined) {
      writer.uint32(24).bool(message.isAutoTranslated);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isAutoTranslated = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateEntry {
    return {
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : "",
      text: isSet(object.text) ? globalThis.String(object.text) : undefined,
      isAutoTranslated: isSet(object.isAutoTranslated)
        ? globalThis.Boolean(object.isAutoTranslated)
        : isSet(object.is_auto_translated)
        ? globalThis.Boolean(object.is_auto_translated)
        : undefined,
    };
  },

  toJSON(message: UpdateEntry): unknown {
    const obj: any = {};
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    if (message.text !== undefined) {
      obj.text = message.text;
    }
    if (message.isAutoTranslated !== undefined) {
      obj.isAutoTranslated = message.isAutoTranslated;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateEntry>): UpdateEntry {
    return UpdateEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateEntry>): UpdateEntry {
    const message = createBaseUpdateEntry();
    message.languageCode = object.languageCode ?? "";
    message.text = object.text ?? undefined;
    message.isAutoTranslated = object.isAutoTranslated ?? undefined;
    return message;
  },
};

function createBaseLanguageHubTranslationsCreate(): LanguageHubTranslationsCreate {
  return { id: "", translationKey: "", translations: [] };
}

export const LanguageHubTranslationsCreate: MessageFns<LanguageHubTranslationsCreate> = {
  encode(message: LanguageHubTranslationsCreate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.translationKey !== "") {
      writer.uint32(18).string(message.translationKey);
    }
    for (const v of message.translations) {
      LocalizedText.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LanguageHubTranslationsCreate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguageHubTranslationsCreate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.translationKey = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.translations.push(LocalizedText.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LanguageHubTranslationsCreate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      translationKey: isSet(object.translationKey)
        ? globalThis.String(object.translationKey)
        : isSet(object.translation_key)
        ? globalThis.String(object.translation_key)
        : "",
      translations: globalThis.Array.isArray(object?.translations)
        ? object.translations.map((e: any) => LocalizedText.fromJSON(e))
        : [],
    };
  },

  toJSON(message: LanguageHubTranslationsCreate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.translationKey !== "") {
      obj.translationKey = message.translationKey;
    }
    if (message.translations?.length) {
      obj.translations = message.translations.map((e) => LocalizedText.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<LanguageHubTranslationsCreate>): LanguageHubTranslationsCreate {
    return LanguageHubTranslationsCreate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LanguageHubTranslationsCreate>): LanguageHubTranslationsCreate {
    const message = createBaseLanguageHubTranslationsCreate();
    message.id = object.id ?? "";
    message.translationKey = object.translationKey ?? "";
    message.translations = object.translations?.map((e) => LocalizedText.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLanguageHubTranslationsUpdate(): LanguageHubTranslationsUpdate {
  return { id: "", translationKey: undefined, translations: [] };
}

export const LanguageHubTranslationsUpdate: MessageFns<LanguageHubTranslationsUpdate> = {
  encode(message: LanguageHubTranslationsUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.translationKey !== undefined) {
      writer.uint32(18).string(message.translationKey);
    }
    for (const v of message.translations) {
      UpdateEntry.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LanguageHubTranslationsUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguageHubTranslationsUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.translationKey = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.translations.push(UpdateEntry.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LanguageHubTranslationsUpdate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      translationKey: isSet(object.translationKey)
        ? globalThis.String(object.translationKey)
        : isSet(object.translation_key)
        ? globalThis.String(object.translation_key)
        : undefined,
      translations: globalThis.Array.isArray(object?.translations)
        ? object.translations.map((e: any) => UpdateEntry.fromJSON(e))
        : [],
    };
  },

  toJSON(message: LanguageHubTranslationsUpdate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.translationKey !== undefined) {
      obj.translationKey = message.translationKey;
    }
    if (message.translations?.length) {
      obj.translations = message.translations.map((e) => UpdateEntry.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<LanguageHubTranslationsUpdate>): LanguageHubTranslationsUpdate {
    return LanguageHubTranslationsUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LanguageHubTranslationsUpdate>): LanguageHubTranslationsUpdate {
    const message = createBaseLanguageHubTranslationsUpdate();
    message.id = object.id ?? "";
    message.translationKey = object.translationKey ?? undefined;
    message.translations = object.translations?.map((e) => UpdateEntry.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLanguageHubTranslationsDelete(): LanguageHubTranslationsDelete {
  return { id: "" };
}

export const LanguageHubTranslationsDelete: MessageFns<LanguageHubTranslationsDelete> = {
  encode(message: LanguageHubTranslationsDelete, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LanguageHubTranslationsDelete {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguageHubTranslationsDelete();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LanguageHubTranslationsDelete {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: LanguageHubTranslationsDelete): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<LanguageHubTranslationsDelete>): LanguageHubTranslationsDelete {
    return LanguageHubTranslationsDelete.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LanguageHubTranslationsDelete>): LanguageHubTranslationsDelete {
    const message = createBaseLanguageHubTranslationsDelete();
    message.id = object.id ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
